import { openModal } from '@src/reduce/modals';
import { useDispatch } from 'react-redux';

import useNavMenuKey from '@hooks/useNavMenuKey';

import * as C from '@components/Common';
import NavMenu from '@components/NavMenu';

import type { NavMenuItems } from '@type/util';

import Table from './Table';
import type * as T from './type';

function AttendEvent() {
  const dispatch = useDispatch();

  const navMenuItems: NavMenuItems<T.NavMenuType> = [{ key: 'list', label: '행사 목록' }];

  const navMenuKey = useNavMenuKey<T.NavMenuType>(navMenuItems[0].key);

  const openCreateAttendEventModal = () => {
    dispatch(openModal({ name: 'createAttendEventModal' }));
  };

  return (
    <C.Container>
      <C.Title>행사 관리</C.Title>
      <NavMenu
        items={navMenuItems}
        defaultKey='list'
        rightButtons={[{ text: '행사 등록', type: 'primary', onClick: openCreateAttendEventModal }]}
      />
      {navMenuKey === 'list' && <Table />}
    </C.Container>
  );
}

export default AttendEvent;
